import PropTypes from 'prop-types';
import { useState } from 'react';
import ICONS from '../../../../../../common-utils/enums/icons';
import Dropdown from '../../../../../../common-utils/components/renders/dropdown/Dropdown';
import { nsCustomization } from '@/app/i18n/namespaces';
import ModalUpdateLabel from '../modals/ModalUpdateLabel';
import ModalDeleteCustomization from '../modals/ModalDeleteCustomization';
import ModalQrCode from '../modals/ModalQrCode';
import { useNavigate } from 'react-router-dom';
import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';
import RouteUrls from '@/app/root/enums/RouteUrls';
import CUSTOMIZATION_URL_ACTIONS from '../../enums/CustomizationUrlActions';
import MERCHANT_ACCOUNT_DETAILS_TABS from '@/app/root/enums/tabs/MerchantAccountDetailsTabs';

/**
 *
 * @param root0
 * @param root0.customization
 * @param root0.setLaunchRefetch
 * @returns {JSX}
 */
function DropdownCustomizationActionsRow({ customization, setLaunchRefetch, merchantAccountId }) {

    // Router
    const navigate = useNavigate();


    //State
    const [showModalUpdateLabel, setShowModalUpdateLabel] = useState(false);
    const [showModalDeleteCustomization, setShowModalDeleteCustomization] = useState(false);
    const [showModalQrCode, setShowModalQrCode] = useState(false);

    //Functions
    const handleShowModalUpdateLabel = () => {
        setShowModalUpdateLabel(true);
    };

    const handleDuplicateCustomization = () => {
        const newCustomization = buildUrl(
            replaceParameters(RouteUrls.PAYLUDD_CUSTOMIZATION_MANAGEMENT.url, { contractAccessId: merchantAccountId, customizationId: customization.uuid }),
            {
                view: MERCHANT_ACCOUNT_DETAILS_TABS.CUSTOMIZATION.name,
                action: CUSTOMIZATION_URL_ACTIONS.DUPLICATE
            }
        );
        navigate(newCustomization);
    };

    const handleQrCode = () => {
        setShowModalQrCode(true);
    };

    const handleDeleteCustomization = () => {
        setShowModalDeleteCustomization(true);
    };


    return (
        <>
            <Dropdown
                triggerValues={{ variant: 'ghostNoBorder', icon: ICONS.MORE }}
                actions={[
                    {
                        icon: ICONS.CONTENT_COPY,
                        entity: 'actions.row.duplicate',
                        namespace: nsCustomization,
                        onClick: handleDuplicateCustomization,
                        visible: customization?.packageCode
                    },
                    {
                        icon: ICONS.EDIT,
                        entity: 'actions.row.edit_label',
                        namespace: nsCustomization,
                        onClick: handleShowModalUpdateLabel,
                        visible: customization?.packageCode
                    },
                    {
                        icon: ICONS.QR_CODE,
                        entity: 'actions.row.qr_code',
                        namespace: nsCustomization,
                        onClick: handleQrCode,
                        visible: customization.packageCode,
                        disabled: !customization.packageCode
                    },
                    {
                        icon: ICONS.DELETE,
                        entity: 'actions.row.delete',
                        namespace: nsCustomization,
                        onClick: handleDeleteCustomization,
                        visible: !customization.posTerminalsNumbers
                    }
                ]}
            />
            {
                showModalUpdateLabel &&
                <ModalUpdateLabel
                    isOpen={showModalUpdateLabel}
                    setIsOpen={setShowModalUpdateLabel}
                    customization={customization}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
            {
                showModalDeleteCustomization &&
                <ModalDeleteCustomization
                    isOpen={showModalDeleteCustomization}
                    setIsOpen={setShowModalDeleteCustomization}
                    customization={customization}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
            {
                showModalQrCode &&
                <ModalQrCode
                    isOpen={showModalQrCode}
                    setIsOpen={setShowModalQrCode}
                    customization={customization}
                />
            }
        </>
    );
}

DropdownCustomizationActionsRow.propTypes = {
    customization: PropTypes.object.isRequired,
    setLaunchRefetch: PropTypes.func,
    merchantAccountId: PropTypes.string.isRequired
};

export default DropdownCustomizationActionsRow;